import script from "./UserAuthTile.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAuthTile.vue?vue&type=script&setup=true&lang=js"

import "./UserAuthTile.vue?vue&type=style&index=0&id=c1291aa4&scoped=true&lang=css"
script.__scopeId = "data-v-c1291aa4"

export default script